import { Injectable, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/auth.service';
import { AuthService as GeneratedAuthService } from '../../modules/api';
import type { LoginRequest, RegisterRequest, UserResponse } from '../../modules/api';

export interface AuthFlowResult {
  success: boolean;
  error?: string;
}

export interface OauthStatus {
  yandex: boolean;
  google: boolean;
}

@Injectable({ providedIn: 'root' })
export class AuthFlowService {
  private router = inject(Router);
  private authService = inject(AuthService);
  private authApi = inject(GeneratedAuthService);

  readonly oauthLoaded = signal<boolean>(false);
  readonly oauthEnabled = signal<OauthStatus>({ yandex: false, google: false });

  constructor() {
    this.loadOauthStatus();
  }

  private loadOauthStatus() {
    this.authApi.oauthProvidersStatusApiAuthOauthProvidersGet().subscribe({
      next: (status) => {
        this.oauthEnabled.set({ yandex: !!status.yandex, google: !!status.google });
        this.oauthLoaded.set(true);
      },
      error: () => {
        this.oauthEnabled.set({ yandex: false, google: false });
        this.oauthLoaded.set(true);
      }
    });
  }

  oauthLogin(provider: string) {
    window.location.href = `/api/auth/oauth/${provider}`;
  }

  login(
    request: LoginRequest,
    onSuccess?: () => void
  ): Promise<AuthFlowResult> {
    return new Promise((resolve) => {
      this.authApi.loginApiAuthLoginPost(request).subscribe({
        next: (tokenResponse) => {
          this.authService.setToken(tokenResponse.access_token, tokenResponse.refresh_token);
          this.authApi.getMeApiAuthMeGet().subscribe({
            next: (user: UserResponse) => {
              this.authService.setCurrentUser(user);
              onSuccess?.();
              resolve({ success: true });
            },
            error: (err: any) => {
              console.error('Failed to get user:', err);
              resolve({ success: false, error: 'Ошибка при получении данных пользователя' });
            }
          });
        },
        error: (err: any) => {
          resolve({ success: false, error: err.error?.detail || 'Неверный email или пароль' });
        }
      });
    });
  }

  register(
    request: RegisterRequest,
    onSuccess?: () => void
  ): Promise<AuthFlowResult> {
    return new Promise((resolve) => {
      this.authApi.registerApiAuthRegisterPost(request).subscribe({
        next: (user: UserResponse) => {
          this.authApi.loginApiAuthLoginPost({
            email: request.email,
            password: request.password
          }).subscribe({
            next: (tokenResponse) => {
              this.authService.setToken(tokenResponse.access_token, tokenResponse.refresh_token);
              this.authService.setCurrentUser(user);
              onSuccess?.();
              resolve({ success: true });
            },
            error: () => {
              resolve({ success: false, error: 'Регистрация успешна, но не удалось войти. Пожалуйста, войдите.' });
            }
          });
        },
        error: (err: any) => {
          resolve({ success: false, error: err.error?.detail || 'Ошибка при регистрации' });
        }
      });
    });
  }

  quickLogin(onSuccess?: () => void): Promise<AuthFlowResult> {
    return this.login(
      { email: '2@mkvm.com', password: 'test123' },
      onSuccess
    );
  }

  navigateAfterAuth() {
    this.router.navigate(['/']);
  }
}
